import { apm as agent } from "@elastic/apm-rum";
import type { OttoNexus } from "../../nexus/index.js";
import type { NexusHandler } from "../../nexus/function/function.types.js";
import { captureError, type APMLabelsMap } from "./captureError.js";

/**
 *
 *
 *
 *
 *
 *
 */
export const buildMessage = (namespace: string, data: Record<string, unknown>): string =>
  namespace.concat(
    ": ",
    Object.entries(data)
      .map(([key, value]) => `${key}: ${value}`)
      .join(", "),
  );

/**
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function normalizeParameterInput(
  dataOrLabels: string | Error | APMLabelsMap,
  labels?: APMLabelsMap,
): {
  labels: APMLabelsMap;
  message: string | Error | undefined;
} {
  if (typeof dataOrLabels === "string" || dataOrLabels instanceof Error) {
    return { labels: { ...labels }, message: dataOrLabels };
  }

  const { message, ...data } = dataOrLabels;
  return { labels: data, message: message as string | undefined };
}

/**
 *
 */
export const sendCustomError = ((
  namespace: string,
  dataOrLabels: string | Error | APMLabelsMap,
  labelsOrUndefined?: APMLabelsMap,
) => {
  /*                */
  if (!agent) return null;

  /*                                                     */
  const { labels, message } = normalizeParameterInput(dataOrLabels, labelsOrUndefined);

  /*                                                                             */
  /*                                 */
  const error =
    message instanceof Error ? message : new Error(message || buildMessage(namespace, labels));

  /*                                              */
  return captureError(error, labels as never, { type: namespace, custom: labels });
}) satisfies NexusHandler<OttoNexus["apm"]["sendCustomError"]>;
